<template>
	<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
		<div class="item_info">
			<div class="item_title">报销单信息</div>
			<el-descriptions class="margin-top" :column="3" border>
				<el-descriptions-item label="报销单号">{{ detailData.code }}</el-descriptions-item>
				<el-descriptions-item label="报销日期">{{ detailData.costDate }}</el-descriptions-item>
				<el-descriptions-item label="报销内容">{{ detailData.content }}</el-descriptions-item>
				<el-descriptions-item label="报销金额"><span style="color: #f56c6c; font-weight: bold" v-money="detailData.money">¥{{ detailData.money }}</span></el-descriptions-item>
				<el-descriptions-item label="支付方式">
					<el-tag v-if="detailData.payUserType === 1" type="info">个人</el-tag>
					<el-tag v-else type="warning">公司</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="分摊类型">
					<el-tag v-if="detailData.isAllocated" type="warning">多门店</el-tag>
					<el-tag v-else>单门店</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="分摊门店数">{{ detailData.allocationCount }}</el-descriptions-item>
				<el-descriptions-item label="报销人">{{ detailData.creator }}</el-descriptions-item>
				<el-descriptions-item label="报销时间">{{ detailData.createTime }}</el-descriptions-item>
				<el-descriptions-item label="是否审核">
					<el-tag v-if="detailData.isConfirm" type="success">已审核</el-tag>
					<el-tag v-else type="danger">未审核</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="审核人">{{ detailData.confirmUserName || "-" }}</el-descriptions-item>
				<el-descriptions-item label="审核时间">{{ detailData.confirmTime || "-" }}</el-descriptions-item>
				<el-descriptions-item label="是否支付">
					<el-tag v-if="detailData.isPay" type="success">已支付</el-tag>
					<el-tag v-else type="danger">未支付</el-tag>
				</el-descriptions-item>
				<el-descriptions-item label="支付人">{{ detailData.payUserName || "-" }}</el-descriptions-item>
				<el-descriptions-item label="支付时间">{{ detailData.payTime || "-" }}</el-descriptions-item>
				<el-descriptions-item span="2" label="备注">{{ detailData.remark || "-" }}</el-descriptions-item>
			</el-descriptions>
		</div>
		<div v-if="detailData.allocations && detailData.allocations.length > 0" class="item_info">
			<div class="item_title">分摊明细</div>
			<el-table :cell-class-name="$moneyCellClass" :data="detailData.allocations" border stripe style="width: 100%">
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
				<el-table-column prop="storeName" label="门店名称" align="center"></el-table-column>
				<el-table-column prop="money" label="分摊金额" align="center">
					<template #default="scope">
						<span style="color: #f56c6c" v-money="scope.row.money">¥{{ scope.row.money }}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
import { GetReimbursementDetail } from "@/api/storeCostApi.js";
export default {
	props: [],
	data() {
		return {
			loading: false,
			detailData: {}
		};
	},
	components: {},
	created() {},
	methods: {
		getDetail(row) {
			this.resetData();
			this.loading = true;
			GetReimbursementDetail({ keyId: row.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.detailData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取详情失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		resetData() {
			this.detailData = {};
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
}

.item_info {
	margin-bottom: 15px;
}

.item_title {
	font-weight: bold;
	margin-bottom: 10px;
	padding-left: 10px;
	border-left: 4px solid #409eff;
}

.margin-top {
	margin-top: 10px;
}

.el-descriptions__label {
	font-weight: bold;
}
</style>
